
import { Component, Prop, Vue } from "vue-property-decorator";
import TranslationJobSummaryCards from "./translation-job-summary-cards.vue";
import FormHeaderTranslation from "@/components/form/elements/form-header-translation/form-header-translation.vue";

type AnalysisResult = {
    tokens: number | null;
    words: number | null;
    pages: number | null;
    costPoint: number | null;
};

@Component({
    components: {
        "ivc-translation-job-summary-cards": TranslationJobSummaryCards,
        "ivc-form-header-translation": FormHeaderTranslation,
    },
})
export default class TranslationJobAnalyzeModal extends Vue {
    @Prop({ type: Boolean, default: false })
    visible!: boolean;

    @Prop({ type: Number, default: 1 })
    step!: number;

    @Prop({ type: Boolean, default: false })
    isAnalyzing!: boolean;

    @Prop({ type: Boolean, default: false })
    isConverting!: boolean;

    @Prop({ type: Boolean, default: false })
    isCreating!: boolean;

    @Prop({ type: Object, required: true })
    form!: Record<string, any>;

    @Prop({ type: [String, Object], required: true })
    infAnalyze!: any;

    @Prop({ type: Object, default: null })
    analysisResult!: AnalysisResult | null;

    @Prop({ type: String, default: "" })
    fileIconWrapperClass!: string;

    @Prop({ type: String, default: "" })
    fileIconClass!: string;

    @Prop({ type: String, default: "-" })
    sourceLangLabel!: string;

    @Prop({ type: Number, default: 0 })
    currentBalance!: number;

    @Prop({ type: Number, default: 0 })
    balanceAfter!: number;

    get hasSufficientBalance() {
        return this.balanceAfter >= 0;
    }

    get visibleProxy() {
        return this.visible;
    }
    set visibleProxy(value: boolean) {
        this.$emit("update:visible", value);
    }

    get formProxy() {
        return this.form;
    }
    set formProxy(value: Record<string, any>) {
        this.$emit("update:form", value);
    }

    get submitPortalId() {
        return `translation-job-submit-${this.portalUid}`;
    }

    get headerMeta() {
        return { name: "headerStepper" } as any;
    }

    private get portalUid() {
        return (this as any)._uid ?? "0";
    }
}
